// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '코오롱제약',
  targetSheetName: '품목수수료표',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '번호',
    '제품명',
    '보험코드',
    '성분명',
    '약가',
    '수수료',
    '변경 (26년4월)',
    '비고',
    '생동유무',
    '생산',
    '분류',
  ],
});
